// ----------------------------------------------------------------------

const account = {
  displayName: 'Narayana Reddy',
  email: 'narayanreddieui@gmail.com',
  photoURL: '/static/mock-images/avatars/avatar_6.jpg',
};

export default account;
